<template>
	<div class="box">
		<div class="slide zoom" ref="main_house2" v-parallax-fit="parallax"></div>
	</div>
</template>

<script>
import { store } from '../../store';

export default {
	name: 'slide20',
	created() {
		this.$watch('store.lang', newVal => {
			if(Object.values(this.subtitlesUrl).includes(this.$subtitlesUrl.value)) {
				this.$subtitlesUrl.value = this.subtitlesUrl[newVal]
			}
		}, { immediate: true });
	},
	mounted() {
		const evidence = {
			items: [
				{
					image: '/themes/rise-theme/dist/images/estate/character-view/vanessa/evidence/11.jpg',
					url: 'https://www.forbes.com/sites/morganbrennan/2013/06/04/wall-street-buying-leads-to-housing-boom-is-a-new-bubble-on-the-way/?sh=96e0eaff02f6',
					link_title: {
						'en': 'Wall Street Buying Adds To Housing Boom. Is A New Bubble On The Way?',
						'es': 'Las compras de Wall Street se suman al auge de la vivienda. ¿Hay una nueva burbuja en camino?'
					}
				},
			],
			text: {
				'en': '"Billionaires, private equity firms and hedge funds have been swooping into the hardest-hit markets across the country and snapping up single-family homes by the tens of thousands. They\'re plucking distressed properties out of the foreclosure pipeline with the aim of playing the housing recovery in the most direct means possible--as landlords."',
				'es': '"Los multimillonarios, las firmas de capital privado y los fondos de cobertura se han abalanzado sobre los mercados más afectados en todo el país y se han apoderado de viviendas unifamiliares por decenas de miles. Están sacando propiedades en dificultades de la tubería de ejecución hipotecaria con el objetivo de jugando la recuperación de la vivienda de la manera más directa posible: como propietarios".'
			}
		};
		const text = {
			'en': 'With home prices at an all time low, corporate landlords bought up huge numbers of homes and began renting them out as it presented a business opportunity to financial investors.',
			'es': 'Con los precios de las viviendas en su punto más bajo, los propietarios corporativos compraron una gran cantidad de viviendas y comenzaron a alquilarlas, ya que presentaba una oportunidad comercial para los inversores financieros.'
		};

		const audio = '/themes/rise-theme/resources/assets/audio/vanessa/3.mp3';
		this.mutationObserver = new window.MutationObserver(mutationList => {
			mutationList.forEach(mutation => {
				if (mutation.target.style.transform == 'translateY(0px) rotateZ(0deg)') {
					this.$audioUrl.value = audio;
					this.$subtitlesUrl.value = this.subtitlesUrl[store.lang];
					this.$readMore.value = text;
					this.$evidence.value = JSON.stringify(evidence);
				}
			});
		});

		this.mutationObserver.observe(this.$refs.main_house2, {
			attributes: true,
			attributeFilter: ['style']
		});
	},
	unmounted() {
		this.mutationObserver.disconnect();
	},
	data() {
		return {
			store,
			subtitlesUrl: {
				'en': '/themes/rise-theme/resources/assets/audio/vanessa/3.srt',
				'es': '/themes/rise-theme/resources/assets/audio/vanessa/3_es.srt'
			},
			mutationObserver: null,
			parallax: [
				{
					start: 23000,
					end: 23700,
					fromStyle: { transform: 'translateY(-1600px) rotateZ(-15deg)' },
					toStyle: { transform: 'translateY(0px) rotateZ(0deg)' },
					easing: 'linear'
				},
				{
					start: 23800,
					end: 24000,
					fromStyle: { transform: 'translateY(0px) rotateZ(0deg) rotateX(0deg)' },
					toStyle: { transform: 'translateY(0px) rotateZ(0deg) rotateX(1deg)' },
					easing: 'linear'
				},
			]
		};
	},
}
</script>

<style lang="scss" scoped>
.box {
	position: fixed;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	z-index: 1;
}

.slide {
	position: absolute;
	background: url('/themes/rise-theme/dist/images/estate/character-view/vanessa/04_House_New.png') no-repeat center;
	background-size: contain;
	width: 940px;
	height: 650px;
	left: calc(50% - 348px);
	top: calc(50% - 295px);
	z-index: 1;

	@media(max-width: 600px) {
		zoom: 0.4;
		left: calc(50% - 468px);
	}
}
</style>
